import { render, staticRenderFns } from "./EditCategories.vue?vue&type=template&id=4dc27dc9&scoped=true"
import script from "./EditCategories.vue?vue&type=script&lang=js"
export * from "./EditCategories.vue?vue&type=script&lang=js"
import style0 from "./EditCategories.vue?vue&type=style&index=0&id=4dc27dc9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc27dc9",
  null
  
)

export default component.exports